import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import { GlobalStyle } from '../../global/global';
import StyledButton from '../../components/Button/Button';
import { Box, Flex, Text, Image, Hide, Divider } from '@chakra-ui/react';
import { StyledHeading } from '../../sections/CalltoActionSection/styles';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=314432&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - strona Wealthon',
};

export default function WealthonPage(props: Props) {
    const howToApplyForLoaAtWealthonItems = [
        {
            svgIcon: (
                <>
                    <svg
                        // height="69"
                        width="14"
                        height="40"
                        viewBox="0 0 14 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M0.944 7.6V0.633998H13.958V40H6.182V7.6H0.944Z" fill="#1AAC7A" />
                    </svg>
                </>
            ),
            title: 'Złóż wniosek na wealthon.com',
            text: 'Potrzebujesz zaledwie kilku danych: NIP, nr telefonu oraz adres e-mail.',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="28"
                        height="41"
                        viewBox="0 0 28 41"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M3.238 32.468C6.694 29.588 9.448 27.194 11.5 25.286C13.552 23.342 15.262 21.326 16.63 19.238C17.998 17.15 18.682 15.098 18.682 13.082C18.682 11.246 18.25 9.806 17.386 8.762C16.522 7.718 15.19 7.196 13.39 7.196C11.59 7.196 10.204 7.808 9.232 9.032C8.26 10.22 7.756 11.858 7.72 13.946H0.376C0.52 9.626 1.798 6.35 4.21 4.118C6.658 1.886 9.754 0.769997 13.498 0.769997C17.602 0.769997 20.752 1.868 22.948 4.064C25.144 6.224 26.242 9.086 26.242 12.65C26.242 15.458 25.486 18.14 23.974 20.696C22.462 23.252 20.734 25.484 18.79 27.392C16.846 29.264 14.308 31.532 11.176 34.196H27.106V40.46H0.43V34.844L3.238 32.468Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Udostępnij historię rachunku',
            text: 'Wealthon poprosi o historię rachunku firmowego z ostatnich 12 miesięcy.',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="28"
                        height="42"
                        viewBox="0 0 28 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.97 12.002C1.15 8.402 2.41 5.63 4.75 3.686C7.126 1.706 10.24 0.715997 14.092 0.715997C16.72 0.715997 18.97 1.184 20.842 2.12C22.714 3.02 24.118 4.262 25.054 5.846C26.026 7.394 26.512 9.158 26.512 11.138C26.512 13.406 25.918 15.332 24.73 16.916C23.578 18.464 22.192 19.508 20.572 20.048V20.264C22.66 20.912 24.28 22.064 25.432 23.72C26.62 25.376 27.214 27.5 27.214 30.092C27.214 32.252 26.71 34.178 25.702 35.87C24.73 37.562 23.272 38.894 21.328 39.866C19.42 40.802 17.116 41.27 14.416 41.27C10.348 41.27 7.036 40.244 4.48 38.192C1.924 36.14 0.574 33.116 0.43 29.12H7.774C7.846 30.884 8.44 32.306 9.556 33.386C10.708 34.43 12.274 34.952 14.254 34.952C16.09 34.952 17.494 34.448 18.466 33.44C19.474 32.396 19.978 31.064 19.978 29.444C19.978 27.284 19.294 25.736 17.926 24.8C16.558 23.864 14.434 23.396 11.554 23.396H9.988V17.186H11.554C16.666 17.186 19.222 15.476 19.222 12.056C19.222 10.508 18.754 9.302 17.818 8.438C16.918 7.574 15.604 7.142 13.876 7.142C12.184 7.142 10.87 7.61 9.934 8.546C9.034 9.446 8.512 10.598 8.368 12.002H0.97Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Potwierdź tożsamość',
            text: 'Tożsamość potwierdzisz online, wystarczy klika kliknięć!',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="32"
                        height="39"
                        viewBox="0 0 32 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.538 31.332V25.392L18.196 0.119998H26.998V24.744H31.75V31.332H26.998V39H19.438V31.332H0.538ZM19.924 8.22L8.854 24.744H19.924V8.22Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Zaakceptuj umowę online',
            text: 'Wszystkie formalności, w tym podpisanie umowy, załatwisz online.',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="28"
                        height="40"
                        viewBox="0 0 28 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M25.322 7.168H7.826V16.402C8.582 15.466 9.662 14.71 11.066 14.134C12.47 13.522 13.964 13.216 15.548 13.216C18.428 13.216 20.786 13.846 22.622 15.106C24.458 16.366 25.79 17.986 26.618 19.966C27.446 21.91 27.86 23.998 27.86 26.23C27.86 30.37 26.672 33.7 24.296 36.22C21.956 38.74 18.608 40 14.252 40C10.148 40 6.872 38.974 4.424 36.922C1.976 34.87 0.59 32.188 0.266 28.876H7.61C7.934 30.316 8.654 31.468 9.77 32.332C10.922 33.196 12.38 33.628 14.144 33.628C16.268 33.628 17.87 32.962 18.95 31.63C20.03 30.298 20.57 28.534 20.57 26.338C20.57 24.106 20.012 22.414 18.896 21.262C17.816 20.074 16.214 19.48 14.09 19.48C12.578 19.48 11.318 19.858 10.31 20.614C9.302 21.37 8.582 22.378 8.15 23.638H0.914V0.526H25.322V7.168Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Poczekaj na decyzję kredytową',
            text: ' Sama decyzja o przyznaniu pożyczki zapada nawet w 30 minut.',
        },
        {
            svgIcon: (
                <>
                    <svg
                        width="29"
                        height="42"
                        viewBox="0 0 29 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M20.274 11.462C19.914 9.95 19.284 8.816 18.384 8.06C17.52 7.304 16.26 6.926 14.604 6.926C12.12 6.926 10.284 7.934 9.096 9.95C7.944 11.93 7.35 15.17 7.314 19.67C8.178 18.23 9.438 17.114 11.094 16.322C12.75 15.494 14.55 15.08 16.494 15.08C18.834 15.08 20.904 15.584 22.704 16.592C24.504 17.6 25.908 19.076 26.916 21.02C27.924 22.928 28.428 25.232 28.428 27.932C28.428 30.488 27.906 32.774 26.862 34.79C25.854 36.77 24.36 38.318 22.38 39.434C20.4 40.55 18.042 41.108 15.306 41.108C11.562 41.108 8.61 40.28 6.45 38.624C4.326 36.968 2.832 34.664 1.968 31.712C1.14 28.724 0.726 25.052 0.726 20.696C0.726 14.108 1.86 9.14 4.128 5.792C6.396 2.408 9.978 0.715997 14.874 0.715997C18.654 0.715997 21.588 1.742 23.676 3.794C25.764 5.846 26.97 8.402 27.294 11.462H20.274ZM14.766 21.29C12.858 21.29 11.256 21.848 9.96 22.964C8.664 24.08 8.016 25.7 8.016 27.824C8.016 29.948 8.61 31.622 9.798 32.846C11.022 34.07 12.732 34.682 14.928 34.682C16.872 34.682 18.402 34.088 19.518 32.9C20.67 31.712 21.246 30.11 21.246 28.094C21.246 26.006 20.688 24.35 19.572 23.126C18.492 21.902 16.89 21.29 14.766 21.29Z"
                            fill="#1AAC7A"
                        />
                    </svg>
                </>
            ),
            title: 'Sprawdź stan konta',
            text: 'Wypłata środków może nastąpić już tego samego dnia! ',
        },
    ];

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title={<>Finansowanie dla twojego sklepu internetowego</>}
                image={heroImage}
                // badgeLabel="SZABLON SKLEPU"
                subTitle="Wealthon POSCASH e-commerce to nowoczesne finansowanie, które jest dostosowane do twojego biznesu online. Zyskaj nawet do 500 tys. złotych i bezpiecznie spłacaj ratę, której wysokość jest dostosowana do obrotów twojej e-firmy."
                buttons={[
                    {
                        title: 'Poznaj szczegóły',
                        href: '#modern-financing',
                        variant: 'default',
                    },
                ]}
            />
            {/*  */}
            <Flex
                className="homepage containerIdosellPages"
                direction={'column'}
                gap={{
                    base: 16,
                    md: 24,
                }}
                py={{
                    base: 16,
                    md: 24,
                }}
            >
                {/*  */}
                <Flex gap={16} alignItems={'center'}>
                    <Hide below="lg">
                        <Box
                            display={'flex'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            minW={'25%'}
                        >
                            <Image src="https://www.iai-system.com/panel/file-gate.php?id=314189&ext=.jpg" />
                        </Box>
                    </Hide>
                    <Flex flexDirection={'column'}>
                        <StyledHeading style={{ textAlign: 'left' }}>
                            Jak działa Wealthon POSCASH
                            <span style={{ whiteSpace: 'nowrap' }}> e-commerce</span>?
                        </StyledHeading>
                        <Text
                            fontSize={{
                                base: 'md',
                                md: 'lg',
                            }}
                            mt={5}
                        >
                            Wealthon POSCASH e-commerce to elastyczna pożyczka dla e-sklepu, którą
                            możesz otrzymać na dowolny cel firmowy.
                            <br />
                            <br />
                            Zdolność kredytowa obliczana jest na podstawie obrotów w sklepie
                            internetowym. Spłata następuję automatycznie, na koniec każdego tygodnia
                            i dzięki temu jest praktycznie niezauważalna.
                            <br />
                            <br />
                            Pożyczkę możesz przeznaczyć na dowolny cel - np. rozbudowę e-sklepu,
                            inwestycję w marketing lub sezonowe zwiększenie zatowarowania. Wszystko
                            jest w zasięgu kilku kliknięć, a Wealthon nie pyta, na co zostaną wydane
                            pieniądze.
                        </Text>
                    </Flex>
                </Flex>
                {/*  */}
                <Flex direction={'column'}>
                    <StyledHeading>Najważniejsze korzyści finansowania Wealthon</StyledHeading>

                    <Flex
                        flexWrap={'wrap'}
                        // gap={{
                        //     base: 4,
                        //     lg: 0,
                        // }}
                        rowGap={{
                            base: 4,
                            md: 12,
                        }}
                        columnGap={{
                            base: 4,
                            lg: 1,
                        }}
                        mt={7}
                        justifyContent={'space-between'}
                    >
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Elastyczna spłata
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Nie martw się wysokością raty. W Wealthon spłacasz cyklicznie
                                    niską kwotę, ale jeśli masz przypływ gotówki, możesz spłacić
                                    pożyczkę szybciej.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Bezobsługowość
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Nie musisz pamiętać o terminie spłaty raty, wszystko odbywa się
                                    automatycznie.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Płynność finansowa
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Wysokość raty jest ustalana indywidualnie, po przeanalizowaniu
                                    obrotów twojego e-sklepu. Wealthon określa wszystkie koszty z
                                    góry, dlatego nic cię nie zaskoczy.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ base: '30px', md: '305px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Minimum formalności
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Do złożenia wniosku wystarczą podstawowe dane o firmie oraz
                                    dowód osobisty właściciela.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ base: '30px', md: '305px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Brak biurokracji
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Wealthon nie wymaga żadnych dokumentów finansowych, wszystko
                                    załatwisz wygodnie online.
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ base: '30px', md: '305px' }}
                            w={{
                                base: '100%',
                                lg: '31%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Błyskawiczna decyzja
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Wypłata środków z pożyczki może nastąpić już tego samego dnia, w
                                    którym złożyłeś wniosek.
                                </Text>
                            </Box>
                        </Flex>
                    </Flex>
                </Flex>

                {/*  */}
                <Flex direction={'column'}>
                    <StyledHeading>Jak wnioskować o pożyczkę w Wealthon w 6 krokach?</StyledHeading>
                    <Flex
                        flexWrap={'wrap'}
                        columnGap={5}
                        rowGap={14}
                        justifyContent={'space-between'}
                        mt={8}
                    >
                        {howToApplyForLoaAtWealthonItems.map((item, index) => {
                            return (
                                <Flex
                                    key={`${index}-${item.title}`}
                                    gap={6}
                                    width={{
                                        base: '100%',
                                        lg: '30%',
                                    }}
                                >
                                    <Box
                                        w={{
                                            base: 12,
                                            md: 14,
                                        }}
                                    >
                                        {item.svgIcon}
                                    </Box>
                                    <Flex flexDirection={'column'} gap={1}>
                                        <Text
                                            fontWeight={'600'}
                                            fontSize={'21px'}
                                            color={'black'}
                                            minH={{
                                                base: '40px',
                                                md: '70px',
                                            }}
                                        >
                                            {item.title}
                                        </Text>
                                        {item.text && <Text>{item.text}</Text>}
                                    </Flex>
                                </Flex>
                            );
                        })}
                    </Flex>
                </Flex>
                {/*  */}
                <Box id="modern-financing" pt={5}>
                    <SectionWithPlusTick
                        alignItems={'center'}
                        display={'flex'}
                        flexDirection={'column'}
                        background={'#1AAC7A'}
                        ctaButton={{
                            label: 'Zyskaj środki',
                            href: 'https://rejestracja.wealthon.com/nowy-wniosek/rejestracja?utm_source=Idosell&utm_medium=email&utm_campaign=POSCASH&type=108',
                        }}
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=314190&ext=.webp',

                            alt: 'Zdjęcie Pani z założonymi rękami',
                        }}
                        tickItem={[
                            {
                                title: 'Wszystkie formalności załatwisz online ',
                            },
                            {
                                title: 'Eksperci Wealthon są do stałej dyspozycji i pomocy',
                            },
                            {
                                title: 'Wypłata pożyczki nastąpi w ciągu 24 godzin',
                            },
                        ]}
                    />
                </Box>
                {/*  */}
                <Divider borderColor="#C8C8C8" orientation="horizontal" />
                <ContactSection />
            </Flex>
        </ThemeProvider>
    );
}
